(() => {
  function initReviewSlider(root) {
    const slider = root.querySelector('.st-home-reviews__grid');
    if (!slider || slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';

    const cards = Array.from(slider.querySelectorAll('blockquote'));
    const previous = root.querySelector('[data-review-direction="prev"]');
    const next = root.querySelector('[data-review-direction="next"]');
    const position = root.querySelector('.st-home-reviews__position');
    if (!cards.length || !previous || !next || !position) return;

    const cardLeft = (card) => card.offsetLeft - cards[0].offsetLeft;
    const currentIndex = () => cards.reduce((closest, card, index) =>
      Math.abs(cardLeft(card) - slider.scrollLeft) < Math.abs(cardLeft(cards[closest]) - slider.scrollLeft) ? index : closest, 0);

    function update() {
      const first = currentIndex();
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      const visible = Math.max(1, Math.floor((slider.clientWidth + gap + 1) / (cardWidth + gap)));
      const last = Math.min(cards.length, first + visible);
      position.textContent = visible > 1 ? `${first + 1}–${last} / ${cards.length}` : `${first + 1} / ${cards.length}`;
      previous.disabled = slider.scrollLeft < 2;
      next.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2;
    }

    for (const button of [previous, next]) {
      button.addEventListener('click', () => {
        const direction = button.dataset.reviewDirection === 'next' ? 1 : -1;
        const target = cards[Math.max(0, Math.min(cards.length - 1, currentIndex() + direction))];
        slider.scrollTo({
          left: cardLeft(target),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('.st-home-reviews').forEach(initReviewSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
